<template>
  <div class="popup-map">
    <button
      class="popup-map__open"
      :class="floatLinksRight ? 'float-right' : ''"
      @click="open = true"
    >
      {{label ? translate(label) : translate('Näytä kartalla')}}

      <div
        class="popup-map__open-icon"
        :class="[`popup-map__open-icon--${color}`, small ? 'popup-map__open-icon--small' : '']"
      >
        <ChevronIcon />
      </div>
    </button>

    <template v-if="open">
      <!-- Not clickable on purpose: the modals only close from the close button or Esc. -->
      <div class="popup-map__backdrop">
        <button
          class="popup-map__close"
          type="button"
          :aria-label="translate('Sulje')"
          @click="open = false"
        >
          <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24" fill="none"
            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <line x1="18" y1="6" x2="6" y2="18" />
            <line x1="6" y1="6" x2="18" y2="18" />
          </svg>
        </button>
      </div>

      <div class="popup-map__popup">
        <LeafletMap
          :address="encodeURIComponent(address)"
          :language="language"
          :coordinates="coordinates"
          :apiKey="apiKey"
        />
      </div>

    </template>
  </div>
</template>

<script>
  import utils from './mixins/utils';
  //import GoogleMap from './components/GoogleMap';
  import LeafletMap from './components/LeafletMap';
  import ChevronIcon from './icons/ChevronIcon.vue';


  export default {
    components: {
    //GoogleMap,
    LeafletMap,
    ChevronIcon
    },
    mixins: [utils.translate],
    props: {
      color: {
        type: String,
        default: 'default',
      },
      address: {
        type: String,
        required: true,
      },
      coordinates: {
        type: String,
        default: null,
      },
      apiKey: {
        type: String,
        required: true,
      },
      floatLinksRight: {
        type: Boolean,
        default: false,
        required: false,
      },
      language: {
        type: String,
        default: 'fi',
        required: false,
      },
      small: {
        type: Boolean,
        default: false,
        required: false,
      },
      // Overrides the default 'Näytä kartalla' button label.
      label: {
        type: String,
        default: '',
        required: false,
      }
    },
    data: () => ({
      open: false,
    }),
    watch: {
      // Close on Esc like the other modals do.
      open(isOpen) {
        if (isOpen) {
          document.addEventListener('keydown', this.onKeydown);
        } else {
          document.removeEventListener('keydown', this.onKeydown);
        }
      }
    },
    beforeUnmount() {
      document.removeEventListener('keydown', this.onKeydown);
    },
    methods: {
      toggle() {
        this.open = !this.open;
      },
      onKeydown(event) {
        if (event.key === 'Escape') {
          this.open = false;
        }
      }
    }
  }
</script>

<style lang="scss">
  @import "~styles/definitions";

  .popup-map {
  }

  .popup-map__open {
    @include reset-button(true);
    @include link();
    display: flex;
    align-items: center;
    justify-content: space-between;

    &.float-right {
      margin-left: auto;
    }

    &:focus {
      text-decoration: underline;
    }
  }

  .popup-map__open-icon {
    margin-left: r(8);
    color: $color-green-2025;

    &--pink {
      color: $color-pink;
    }

    &--yellow {
      color: $color-yellow;
    }

    &--small {
      transform: scale(0.7);
      margin-left: r(4);
    }
  }

  .popup-map__backdrop {
    // The anchor link the component renders inside is a pointer, and cursor
    // inherits, so reset it for the overlay.
    cursor: default;
    position: fixed;
    z-index: 200;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    width: 100%;
    height: 100%;
    background-color: $color-modal-backdrop;
  }

  .popup-map__close {
    @include modal-close-button;
  }

  .popup-map__popup {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    margin: r(64) r(8) r(8) r(8);
    z-index: 201;

    @include media-breakpoint-up(sm) {
      margin: r(64);
    }
  }

  .popup-map__map {
    border: none;
    width: 100%;
    height: 100%;
  }
</style>
